import {
  BORDER_WIDTH,
  THUMBNAIL_MAX_HEIGHT,
  THUMBNAIL_MAX_WIDTH,
  THUMBNAIL_MIN_HEIGHT,
  THUMBNAIL_MIN_WIDTH,
} from './Slide.config';

export function reOrder<Type>(list: Type[], startIndex: number, endIndex: number): Type[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export const focusSlide = (draggableId: string): void => {
  const slideEl = document.querySelector(`[data-rbd-draggable-id="${draggableId}"]`);
  if (slideEl) (slideEl as HTMLElement).focus();
};

/**
 * Calculates the thumbnail dimensions for the infographs that are rendered in the slides,
 * ensures that the dimensions are within the specified minimum and maximum constraints while maintaining
 * the original aspect ratio of the image.
 *
 * @function
 * @param {number} naturalWidth - The original width of the image.
 * @param {number} naturalHeight - The original height of the image.
 *
 * @returns {{width: number, height: number}} - The thumbnail dimensions.
 *
 */
export const getThumbnailSize = (naturalWidth: number, naturalHeight: number): { width: number; height: number } => {
  // adjust thumbnail max width and height to account for border width of the slide
  const ADJUSTED_THUMBNAIL_MAX_WIDTH = THUMBNAIL_MAX_WIDTH - BORDER_WIDTH;
  const ADJUSTED_THUMBNAIL_MAX_HEIGHT = THUMBNAIL_MAX_HEIGHT - BORDER_WIDTH;

  const naturalAspect = naturalWidth / naturalHeight;

  let width, height;

  // Start by fitting the image within the minimum boundaries.
  if (naturalAspect > THUMBNAIL_MIN_WIDTH / THUMBNAIL_MIN_HEIGHT) {
    width = Math.max(THUMBNAIL_MIN_WIDTH, naturalWidth);
    height = width / naturalAspect;
  } else {
    height = Math.max(THUMBNAIL_MIN_HEIGHT, naturalHeight);
    width = height * naturalAspect;
  }

  // Check whether dimensions exceed maximum boundaries and scale down if necessary
  if (width > ADJUSTED_THUMBNAIL_MAX_WIDTH || height > ADJUSTED_THUMBNAIL_MAX_HEIGHT) {
    const ratio = Math.min(ADJUSTED_THUMBNAIL_MAX_WIDTH / width, ADJUSTED_THUMBNAIL_MAX_HEIGHT / height);
    width *= ratio;
    height *= ratio;
  }

  return { width, height };
};
